import { render, staticRenderFns } from "./passengers.vue?vue&type=template&id=5bc056c4&scoped=true&"
import script from "./passengers.vue?vue&type=script&lang=ts&"
export * from "./passengers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc056c4",
  null
  
)

export default component.exports